<template>
  <div class="container p-4">
    <h3 class="text-xl font-bold mb-2">SIMCE — Material (Django)</h3>
    <p class="text-sm text-600 mb-4">
      Gestiona ítems de práctica, alternativas, catálogo curricular y plantillas de ensayo.
      Usa la misma sesión Django staff que actividades y juegos.
    </p>

    <DjangoAuthGate variant="full" @authenticated="onDjangoAuth" />

    <div v-if="djangoOk" class="grid grid-cols-1 md:grid-cols-2 gap-3">
      <CardPrime class="cursor-pointer" @click="ir('simce-material')">
        <template #title><i class="pi pi-book mr-2" />Material SIMCE</template>
        <template #content>
          Ítems, opciones, asignaturas, ejes temáticos, plantillas de ensayo e importación Excel.
        </template>
      </CardPrime>
      <CardPrime class="cursor-pointer opacity-70">
        <template #title><i class="pi pi-chart-bar mr-2" />Reportes y práctica</template>
        <template #content>
          Próximamente: acceso al módulo SIMCE desde la app alumno y reportes docente.
        </template>
      </CardPrime>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import CardPrime from 'primevue/card';
import DjangoAuthGate from '@/components/estudyoo/DjangoAuthGate.vue';
import { isDjangoAdminAuthenticated } from '@/services/djangoAdminAuth';

const router = useRouter();
const djangoOk = ref(isDjangoAdminAuthenticated());

function onDjangoAuth(ok) {
  djangoOk.value = !!ok;
}

function ir(name) {
  if (!djangoOk.value) return;
  router.push({ name });
}
</script>
